import React from 'react'
import { Icon } from '@fluentui/react/lib/Icon'
import { /* ChevronLeft,  */ChevronRight, MoreVertical } from 'react-feather';
import { ActionPopup } from '../';

const Edit = () => <Icon iconName="Edit" className="ms-Edit text-xl" />;
const Delete = () => <Icon iconName="Delete" className="ms-Delete text-xl" />;

const LocationRow = ({data, onEdit, onDelete, withAction}) => {
  const [open, setOpen] = React.useState(false)
  const [popedUp, setPopedUp] = React.useState(false)

  const actionButtonClasses = "cursor-pointer text-sm text-white h-full flex flex-col items-center justify-center py-5"
  const actionButtonStyles = {
    minWidth: '67px'
  }

  return (
    <tr className="text-sm text-gray-444 location-row">
      <td className="align-top">
        <div className="text-gray-999 lg:hidden" style={{fontSize: '10px'}}>City</div>
        {data.city}
      </td>
      <td className="align-top">
        <div className="text-gray-999 lg:hidden" style={{fontSize: '10px'}}>Address</div>
        {data.address}
      </td>
      {
        withAction &&
        <td className="relative align-top">
          <div className="hidden lg:flex items-center">
            <p className="cursor-pointer underline text-sm text-gray-444 mr-6" onClick={onEdit}>Edit</p>
            <p className="cursor-pointer underline text-sm text-gray-999" onClick={onDelete}>Delete</p>
          </div>
          <MoreVertical className="lg:hidden text-gray-999" onClick={() => setPopedUp(true)} />
          {
            popedUp &&
            <ActionPopup handleClose={() => setPopedUp(false)} onEdit={onEdit}/>
          }

          {/* Backup */}
          {/* <ChevronLeft className="lg:hidden" onClick={() => setOpen(true)}/> */}
          {
            open &&
            <div className="flex items-center absolute top-0 right-0 h-full">
              <div
                className="h-full flex items-center justify-end pr-4"
                style={{width: '183px', background: 'linear-gradient(270deg, #FFFFFF 27.22%, rgba(255, 255, 255, 0) 95.83%)'}}
                onClick={() => setOpen(false)}
              >
                <ChevronRight />
              </div>
              <div
                className={`bg-primary ${actionButtonClasses}`}
                style={{...actionButtonStyles}}
                onClick={onEdit}
              >
                <Edit/>
                <p className="underline mt-2">Edit</p>
              </div>
              <div
                className={`${actionButtonClasses}`}
                style={{background: '#999', ...actionButtonStyles}}
                onClick={onDelete}
              >
                <Delete/>
                <p className="underline mt-2">Delete</p>
              </div>
            </div>
          }
        </td>
      }
    </tr>
  )
}

const LocationTable = ({onDelete, onEdit, data, withAction = true}) => {
  const handleEdit = (d, index) => {
    if(typeof onEdit === 'function'){
      onEdit(d, index)
    }
  }

  const handleDelete = (d, index) => {
    if(typeof onDelete === 'function'){
      onDelete(d, index)
    }
  }

  return (
    <table className="table table--striped mb-8 lg:mb-0">
      <tbody>
        {
          data.map((d, index) => (
            <LocationRow
              key={d.id ? d.id : index}
              data={d}
              onEdit={() => handleEdit(d, index)}
              onDelete={() => handleDelete(d, index)}
              withAction={withAction}
            />
          ))
        }
      </tbody>
    </table>
  )
}

export { LocationTable }
